import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { MeetingHandlerService, NotificationMessages } from '../../services/meeting-handler.service';
import { MeetingService } from '../../services/meeting.service';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements AfterViewInit, OnChanges, OnDestroy {  
  @Input() hours: number = 0;
  @Input() minutes: number = 0;
  seconds: number = 0;
  @Output() totalSeconds = new EventEmitter<number>();
  @Input() room: string = '';
  elapsedSeconds: number = 0;
  timerInterval: any;
  remainingTime: string = '00:00:00';
  hasTimerStarted = false;
  @Input() editMode: boolean = true;

  constructor(private meetingHandler: MeetingHandlerService, private meetingService: MeetingService) {
    
  }
  ngOnDestroy(): void {
    
  }
  ngOnChanges(changes: SimpleChanges): void {
  }
  
  async ngAfterViewInit(): Promise<void> {
    const mythis = this;
    this.meetingHandler.startRoomCountDown.subscribe((message) => {   
      const {room, duration} = message;
      if(mythis.room == room && !mythis.hasTimerStarted){
        mythis.reformatTimeStamp(duration);
        mythis.startTimer();
        mythis.hasTimerStarted = true;
      }
    });
    
    if(mythis.room && !mythis.editMode){
      let timestamp = await mythis.meetingService.getRoomTimestamp(mythis.meetingHandler.domain, mythis.meetingHandler.jwt, mythis.room);
      
      if (new Date().getTime() < timestamp){
        mythis.reformatTimeStamp(timestamp);
        mythis.startTimer();
        mythis.hasTimerStarted = true;
      }
    }
}

  updateTotalSeconds() {
    if(this.minutes > 59)
      this.minutes = 59;    
    
    this.totalSeconds.emit( (this.hours * 3600) + (this.minutes * 60) );
  }

  startTimer() {
    if ((this.hours * 3600) + (this.minutes * 60) + this.seconds <= 0) return;
    
    this.elapsedSeconds = 0;
    this.timerInterval = setInterval(() => {
      this.elapsedSeconds++;
      this.updateRemainingTime();
    }, 1000);
  }

  updateRemainingTime() {
    const remaining = (this.hours * 3600) + (this.minutes * 60) + (this.seconds) - this.elapsedSeconds;

    if (remaining > 0 && this.meetingHandler.breakoutRooms.get(this.room)) {
      const hh = this.padZero(Math.floor(remaining / 3600));
      const mm = this.padZero(Math.floor((remaining % 3600) / 60));
      const ss = this.padZero(remaining % 60);
      this.remainingTime = `${hh}:${mm}:${ss}`;
    }
    else{
      this.meetingHandler.roomsDurationStoreObj.delete(this.room)
      this.meetingHandler.adjustedRoomDurationObj.delete(this.room);
      this.meetingHandler.breakoutRooms.delete(this.room);
      clearInterval(this.timerInterval);
    }
  }

  padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  incrementHours() {
    this.hours++;
    this.updateTotalSeconds();
  }

  decrementHours() {
    if (this.hours > 0) {
      this.hours--;
      this.updateTotalSeconds();
    }
  }

  incrementMinutes() {
    if (this.minutes < 59) {
      this.minutes++;
    } else {
      this.minutes = 0;
      this.incrementHours();
    }
    this.updateTotalSeconds();
  }

  decrementMinutes() {
    if (this.minutes > 0) {
      this.minutes--;
    } else if (this.hours > 0) {
      this.minutes = 59;
      this.decrementHours();
    }
    this.updateTotalSeconds();
  }

  reformatTimeStamp(timestamp){
    const now = Date.now();
    const end = timestamp;
    const duration = end - now;

    const totalseconds = Math.floor(duration / 1000);    
    this.hours = Math.floor(totalseconds / 3600);
    this.minutes = Math.floor((totalseconds % 3600) / 60);
    this.seconds = totalseconds % 60;
  }
}
